/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetEffectiveNotificationPreferencesByKindQueryResponse,
  GetEffectiveNotificationPreferencesByKindPathParams,
} from '../types/GetEffectiveNotificationPreferencesByKind'

function getGetEffectiveNotificationPreferencesByKindUrl({
  kind_slug,
}: {
  kind_slug: GetEffectiveNotificationPreferencesByKindPathParams['kind_slug']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/notifications/preferences/kind/${kind_slug}/` as const,
  }
  return res
}

/**
 * @summary Get the effective per-preference settings for a kind
 * {@link /api/v1/notifications/preferences/kind/:kind_slug/}
 */
export async function getEffectiveNotificationPreferencesByKind(
  {
    kind_slug,
  }: {
    kind_slug: GetEffectiveNotificationPreferencesByKindPathParams['kind_slug']
  },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetEffectiveNotificationPreferencesByKindQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetEffectiveNotificationPreferencesByKindUrl({
      kind_slug,
    }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
